






















import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, OptionItemType } from '../../types/type'
@Component({
  name: 'AddOrUpdateCanteenIndexConfig',
  components: {
    'form-module': () => import('../../components/common/formModule.vue')
  }
})
export default class AddOrUpdateCanteenIndexConfig extends Vue {
  public loading = false
  public headerOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public bottomOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: `保存`,
      key: 'save',
      type: 'success',
      size: ''
    }
  ]
  // 枚举选项：
  public indexConfigFileTypeOptions: OptionItemType[] = [
    {
      name: '通知公告',
      value: 'INFORM_ANNOUNCEMENT'
    },
    {
      name: '政策文件',
      value: 'POLICY_FILE'
    }
  ]
  public fillInfoList: Array<FillInfoItemOfForm> = [
    {
      title: '配置项类型',
      type: 'select',
      key: 'type',
      value: '',
      placeholder: '请选择配置项类型',
      selectOptions: [],
      isNecessary: true
    },
    {
      title: '发送单位名称',
      type: 'text',
      key: 'organizationName',
      value: '',
      placeholder: '请输入发送单位名称',
      isNecessary: true
    },
    {
      title: '标题',
      type: 'textarea',
      key: 'title',
      value: '',
      placeholder: '请输入标题',
      isNecessary: true
    },
    {
      title: '内容',
      type: 'richText',
      key: 'textDetail',
      value: '',
      placeholder: '请输入内容',
      isNecessary: true
    },
    {
      title: '附件',
      type: 'file',
      key: 'otherInfo',
      value: '',
      placeholder: '请上传附件',
      isNecessary: true,
      uploadSelfForImgForFileButtonFlag: false,
      uploadSelfForImgForFileButtonText: "<span class='el-icon-upload2'></span>上传附件",
      uploadSelfForImgForFileButtonTextAgain: "<span class='el-icon-upload2'></span>上传附件",
      uploadResultList: [],
      upperLimit: 5
    },
    {
      title: '选择接收人员',
      type: 'selectForPageListForUser',
      key: 'sendArray',
      value: '',
      placeholder: '请选择接收人员',
      isNecessary: true,
      selectResultString: ''
    }
  ]

  // 针对详情的：人员列表（利于回显用的）
  public userListForDetail: Array<any> = []

  // 新增编辑的文字展示
  get addOrUpdateTitle (): string {
    let _that: any = this
    let { id } = _that.$route.query
    let res: string = '新增'
    if (id && id !== 'add') {
      res = '编辑'
    }
    return res
  }

  async created () {
    this.disposeForFillInfoList()
    let { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
    if (id !== 'add') this.getDetailInfo()
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    this.fillInfoList = this.fillInfoList.map(item => {
      switch (item.key) {
        case 'type':
          item.selectOptions = this.indexConfigFileTypeOptions
          break
      }
      return item
    })
  }

  async getDetailInfo () {
    try {
      let _that: any = this
      this.loading = true
      let { data: result } = await _that.$http.newAnnouncementGetById({
        id: this.$route.query.id,
        loginUserType: 0
      })
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      let info = result.data || {}
      this.fillInfoList = this.fillInfoList.map(item => {
        const { key } = item
        switch (key) {
          case 'otherInfo':
            item.uploadResultList = JSON.parse(info[key] || '[]')
            break
          case 'sendArray':
            item.disabled = true
            item['explainTextSpecial'] = '说明：编辑时不支持变更接收人员哦'
            const sendArray = JSON.parse(info[key] || '[]')
            for (let i = 0, len = sendArray.length; i < len; i++) {
              this.getSysUserInfo(sendArray[i])
            }
            break
          default:
            item.value = info[key]
            break
        }
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 根据用户id获取用户详情：
  async getSysUserInfo (id) {
    try {
      let { data: result } = await (this as any).$http.getSysUserInfo({ id })
      if (result.code !== 200) return this.$message.error(result.msg)
      let info = result.data
      this.userListForDetail.push(info)
      this.fillInfoList = this.fillInfoList.map(item => {
        const { key } = item
        if (key === 'sendArray') {
          item.value = this.userListForDetail
          item.selectResultString = this.userListForDetail.map(item => item.username).join('、')
        }
        return item
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 上传文件相关：
  updateFillInfoList (fillInfoList: Array<FillInfoItemOfForm>): void {
    this.fillInfoList = JSON.parse(JSON.stringify(fillInfoList))
  }

  // 针对用户选择做处理：
  getUserCheckedList (checkedList) {
    this.fillInfoList = this.fillInfoList.map(item => {
      const { key } = item
      if (key === 'sendArray') {
        item.value = checkedList
        item.selectResultString = checkedList.map(item => item.username).join('、')
      }
      return item
    })
  }

  async saveAll () {
    try {
      // 首先需要处理附件的value:
      this.fillInfoList = this.fillInfoList.map(item => {
        if (item.key === 'otherInfo' && item.uploadResultList.length) item.value = JSON.stringify(item.uploadResultList)
        return item
      })
      let whoEmpty = null
      let isEmpty = this.fillInfoList.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let params = this.fillInfoList.reduce((result, current) => {
        const { key, value } = current
        switch (key) {
          case 'sendArray':
            result[key] = JSON.stringify((value || []).map(item => item.id))
            break
          default:
            result[key] = value
            break
        }
        return result
      }, {})
      Object.assign(params, {
        sendType: 2, // 发送类型 0: 全部用户 1: 组织节点 2: 个人
        module: 'CANTEEN_MODULE' // 模块类型 自定义类型 最好前端创建对应的枚举
      })
      const { id } = this.$route.query
      if (id && id !== 'add') {
        Object.assign(params, { id })
      }
      const { data: result } = await (this as any).$http.newAnnouncementSaveOrUpdate(params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`${this.addOrUpdateTitle}成功`)
      setTimeout(() => {
        this.$router.push({ name: 'CanteenIndexConfig' })
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
      case 'save':
        this.saveAll()
        break
    }
  }
}
